module.exports = __webpack_public_path__ + "img/Offlineexamination.1e0c6ffa.png";